import jwtDecode from "jwt-decode";
import { useMemo } from "react";
import { AccessToken, User } from "./types";

type DecodedToken = {
  given_name: string;
  family_name: string;
  sub: string;
  params: {
    title: string;
    externalId: string;
  } | null;
};

export default function useTokenUserData(token: AccessToken | null): User | null {
  return useMemo(() => {
    if (!token) return null;

    let firstName = "";
    let lastName = "";
    let sub: string | undefined;
    let memberNumber: string | undefined;

    if (token) {
      try {
        const data = jwtDecode(token) as DecodedToken;
        firstName = data.given_name;
        lastName = data.family_name;
        sub = data.sub;
        memberNumber = data.params?.title || data.params?.externalId;
      } catch (e) {}
    }

    return { firstName, lastName, sub, memberNumber };
  }, [token]);
}
